import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import css from "./PeriodsListComponent.module.css";
import { periodsActions } from "../../../store/slices/settings-slices";
import PeriodComponent from "../PeriodComponent/PeriodComponent";


const PeriodsListComponent = () => {
    const dispatch = useDispatch();
    const { periods, trigger } = useSelector((store) => store.periods);

    useEffect(() => {
        dispatch(periodsActions.getAllPeriods());
    }, [trigger]);

    return (
        <section className={css.wrap}>
            <table className={css.table}>
                <thead>
                <tr>
                    <th>Days Count</th>
                    <th>Discount</th>
                    <th>Default</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {periods &&
                    periods.map((obj) => (
                        <PeriodComponent
                            key={obj.id}
                            period={obj}
                        />))
                }
                </tbody>
            </table>
        </section>
    );
};

export default React.memo(PeriodsListComponent);
